import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useHistory } from "../../utils/router";
import { getLink, objectToFormData, toast } from "../../utils/helpers";
import { apiUrl } from "../../utils/apiUrl";
import { postRequest } from "../../utils/request";
import { apiRequest } from "../../hooks/apiRequest";
import FormTemplate from "./FormTemplate";
import Loader from "../general/Loader";

const EditTemplate = () => {
    const { id } = useParams();

    const history = useHistory();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [template, setTemplate] = useState({});
    const [original, setOriginal] = useState({});
    const [esValido, setEsValido] = useState(false);

    const cancelar = () => {
        const from = location.state?.from || getLink("/cartas/plantillas");
        
        history.push(from);
    }

    const editar = async () => {
        if (!esValido) return toast('Favor llenar todos los campos requeridos', 'error');

        setSaving(true);

        setErrors({});
        
        const data = objectToFormData({...template, "_method": "put"});

        const response = await postRequest(apiUrl(`templates/${id}`), data);
                
        if (response.success) {
            history.push(getLink("/cartas/plantillas"));
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }

        setSaving(false);
    };

    const getTemplate = async () => {
        const response = await apiRequest({}, `templates/${id}`, 'get');

        if (response.success) {
            setTemplate(response.data);
            setOriginal(response.data);
        } else {
            toast('Error obteniendo el plantilla', 'error');
            cancelar();
        }

        setLoading(false);
    };

    useEffect(() => {
        getTemplate();
    }, []);

    if (loading) return <Loader></Loader>;

    return <>
        <div className="row">
            <div className="col-md-12 order-2 order-md-1">
                <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                    <h1>Editar Plantilla</h1>

                    <FormTemplate template={template} setTemplate={setTemplate} setEsValido={setEsValido} errors={errors} saving={saving} original={original} />
                </div>
            </div>
        </div>

        <div className="row pt-4">
            <button
                type="button"
                className="btn btn-plain ml-auto mr-2"
                onClick={cancelar}
            >
                Descartar
            </button>

            <button
                type="button"
                className="btn btn-primary ml-2 mr-3"
                onClick={() => editar()}
            >
                Guardar
            </button>
        </div>
    </>;
};

export default EditTemplate;
